import Footer from './HOClevel'

export default Footer
